module.exports = __webpack_public_path__ + "img/logo_sc_branco.0496daea.png";